import type { ScriptDescriptor } from '../../utils/loadScriptOnce';

export const PREFERRED_SOURCE_SCRIPT: ScriptDescriptor = {
  id: 'google-preferred-source-publisher',
  src: 'https://news.google.com/swg/js/v1/publisher.js',
};

/** Rendered height of Google's button, reserved while the script loads so the page doesn't shift. */
export const PREFERRED_SOURCE_BUTTON_HEIGHT_PX = 40;

/** Start loading the script this far before the container scrolls into view. */
export const PREFERRED_SOURCE_ROOT_MARGIN = '200px';

/** How long the loaded script gets to render into the placeholder before the container collapses. */
export const PREFERRED_SOURCE_RENDER_TIMEOUT_MS = 5000;

export const PREFERRED_SOURCE_RENDER_POLL_MS = 250;
